/* eslint-disable no-use-before-define */
import React, { useContext } from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { titleize } from 'underscore.string';
import { getClassName } from 'utils/ui/classes';
import { useTranslation } from 'react-i18next';
import IconTextDisplay from '../v2/IconTextDisplay';
import CalendarIcon from '../v2/icons/CalendarIcon';
import { actionMapping } from '../modules/shipments/mappings';

const OfferStop = ({
  className,
  stop: {
    window_start,
    window_end,
    action,
    appointment_unconfirmed,
    location: locations,
  },
}) => {
  const location = locations[0];

  const cityAndState = `${location.city}, ${location.state}`;
  const isDeliver = action === 'deliver';
  const timezone = location.location_timezone || location.market.timezone;
  return (
    <div className={getClassName('relative', className)}>
      <div className="absolute flex flex-col items-center w-16 h-full -left-4 sm:-left-8">
        <div
          className={classnames('w-3 h-3 mb-1 rounded-full', {
            'bg-green-cm': isDeliver,
            border: !isDeliver,
            'border-green-cm': !isDeliver,
          })}
        />
        <div className="flex-1 w-px border border-green-cm" />
      </div>
      <div className="pb-4 ml-8 border-b border-gray-200 sm:grid sm:grid-cols-2 sm:gap-4">
        <div className="truncate w-60">
          <div
            className="w-24 mb-1 text-sm font-medium text-gray-700"
            title={cityAndState}
          >
            {cityAndState}
          </div>
          {location.name && (
            <p className="mb-1 text-sm" title={location.name}>
              {location.name}
            </p>
          )}
          <p className="mb-1 text-sm" title={location.street}>
            {location.street}
          </p>
          <p
            className="mb-1 text-sm"
            title={`${cityAndState} ${location.zipcode}`}
          >
            {cityAndState} {location.zipcode}
          </p>
        </div>
        <div className="">
          <AppointmentWindow
            window_start={window_start}
            window_end={window_end}
            appointment_unconfirmed={appointment_unconfirmed}
            timezone={timezone}
            action={action}
          />
        </div>
      </div>
    </div>
  );
};

const AppointmentWindow = ({
  action,
  window_start,
  window_end,
  timezone,
  appointment_unconfirmed,
}) => {
  let formattedDate;
  const { t } = useTranslation();

  if (window_start && window_end && !appointment_unconfirmed) {
    formattedDate = formatDate(window_start, window_end, timezone, t);
  } else {
    formattedDate = t('APPOINTMENT_REQUIRED');
  }
  const color = action === 'pickup' ? 'green' : 'red';
  return (
    <IconTextDisplay color={color} icon={<CalendarIcon />}>
      <dl className="text-left">
        <dt className="mb-2 form-label">
          {titleize(t(actionMapping[action]))}
        </dt>
        <dd className="block text-sm text-gray-900">{formattedDate}</dd>
      </dl>
    </IconTextDisplay>
  );
};

function formatDate(windowStart, windowEnd, timezone, t) {
  if (!windowStart && !windowEnd) {
    return t('NOT_SET');
  }

  const start = moment.tz(windowStart, timezone);
  const end = moment.tz(windowEnd, timezone);
  const today = moment();

  if (start.isSame(end, 'day')) {
    if (today.isSame(start, 'year')) {
      return `${start.format('L LT')}-${end.format('LT')}`;
    }
    return `${start.format('L LT')}-${end.format('LT')}`;
  }
  if (today.isSame(start, 'year')) {
    return `${start.format('L LT')}-${end.format('L LT')}`;
  }
  return `${start.format('L LT')}-${end.format('L LT')}`;
}

export default OfferStop;
